// @flow
import { toggleSideBar, updateFullScreen } from '../actions/session';
import { getCurrentWindow, getIsMac, getPrimaryDisplay } from './electron';
import { startTour } from './intercom';

let previousWindowBounds:
  | {
      x: number,
      y: number,
      width: number,
      height: number,
    }
  | typeof undefined;

export const setElectronCaptionMode = (on: boolean, showConversationEndModal?: boolean) => {
  // TODO: Manipulating electron windows from renderer process is hella slow.
  const currentWindow = window.electronCurrentWindow;
  if (on) {
    const { bounds } = window.electronScreen.getPrimaryDisplay();
    const x = Math.round(bounds.x + (bounds.width - 800) / 2);
    const y = Math.round(bounds.y + (bounds.height * 1.6 - 160) / 2);
    if (!previousWindowBounds) {
      previousWindowBounds = {
        x: currentWindow.getPosition()[0],
        y: currentWindow.getPosition()[1],
        width: currentWindow.getSize()[0],
        height: currentWindow.getSize()[1],
      };
    }
    window.store.dispatch(toggleSideBar(false));
    window.store.dispatch(updateFullScreen(true));

    currentWindow.setFullScreen(false);
    currentWindow.setBounds({
      x,
      y,
      width: 800,
      height: 220,
    });
    window.electronIPC.sendSetInCaptionMode(true);
    if (getIsMac()) {
      currentWindow.setWindowButtonVisibility(false);
    }
  } else if (previousWindowBounds) {
    window.store.dispatch(updateFullScreen(false));
    currentWindow.setBounds({
      x: previousWindowBounds.x,
      y: previousWindowBounds.y,
      width: previousWindowBounds.width,
      height: previousWindowBounds.height,
    });
    previousWindowBounds = undefined;
    window.electronIPC.sendSetInCaptionMode(false);
    window.store.dispatch(toggleSideBar(true));
    if (getIsMac()) {
      currentWindow.setWindowButtonVisibility(true);
      // We're on mac. Let's show Intercom Tour, only once!
      const hasAlreadySeenTour = window.electronIPC.sendSyncHasSeenInternalAudioMicTour();
      if (!hasAlreadySeenTour && showConversationEndModal === false) {
        startTour(209258);
      }
    }
  }
};

if (window.electronIPC) {
  window.electronIPC.onSetElectronCaptionMode(setElectronCaptionMode);
}
